import type { ReactNode } from 'react';

export const symbol_shield_watch: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-480Zm173 376-12-61q-38-23-59.5-61.5T560-310q0-45 21.5-83.5T641-455l12-61q2-11 10-17.5t19-6.5h96q11 0 19 6.5t10 17.5l12 61q38 23 59.5 61.5T900-310q0 45-21.5 83.5T819-165l-12 61q-2 11-10 17.5T778-80h-96q-11 0-19-6.5T653-104Zm155-128q32-32 32-78t-32-78q-32-32-78-32t-78 32q-32 32-32 78t32 78q32 32 78 32t78-32ZM160-523v-196q0-19 11-34.5t28-22.5l260-97q11-4 21-4t21 4l260 97q17 7 28 22.5t11 34.5v89q0 13-8.5 21.5T770-600q-13 0-21.5-8.5T740-630v-89l-260-98-260 98v196q0 128 69.5 233.5T480-143q17-6 33-13.5t32-16.5q11-6 23.5-3t18.5 14q6 11 3 23t-14 18q-17 10-34.5 18.5T505-88q-6 2-12.5 3T480-84q-6 0-12.5-1T455-88q-135-45-215-170t-80-265Z"
		/>
	</svg>
);
